import FeatureController from '../FeatureController';

export default class EditMatchController extends FeatureController {

    constructor (panel, $state) {
      super(panel, $state);

      this.profile = {};
      this.register = {};
      this.match = {};
      this.age_range = this.panel.range(17, 100);
      const self = this;
      this.panel.get('/v1/profile/' + this.user.screen_name, (response) => {
          if (self.panel.okay(response)) {
              for (let i in response) {
                  if (i !== 'data') {
                      self[i] = response[i];
                  } else {
                      for (let j in response.data) {
                          self[j] = response.data[j];
                      }
                  }
              }
          }
      });
    }

    redirectUrl (url) {
        history.pushState(null, null, url);
    }

    update_match (redirectUrl) {
      if (!redirectUrl && this.urlParams.hasOwnProperty('r') && this.urlParams.r === 'home') {
        redirectUrl = '/home';
      }
      redirectUrl = isset(redirectUrl) ? redirectUrl : '/profile/'+this.user.screen_name;
        for (let i in this.match) {
            if (this.match[i] != null) {
              this.match[i] = this.match[i].constructor === Array ? this.match[i].join(',') : this.match[i];
            }
        }

        let data = {match:this.match};

        const self = this;

        this.panel.post('/v1/update/match', data, (response) => {
            if (self.panel.okay(response)) {
              self.panel.setHasCompletedMatch(true);
              self.redirectUrl(redirectUrl);
            }
        });
    }

    get_checked_match (k, v) {
      return this.match[k] && this.match[k].indexOf(v+"") > -1;
    }

    push_match (k, v) {
      let match = [];
      if (this.match[k]) {
          match = this.match[k].split(',');
      }
      match.indexOf(v) > -1 && match.splice(match.indexOf(v),1) || match.push(v);
      this.match[k] = match.join(",");
    }
}



// WEBPACK FOOTER //
// ./src/app/features/edit-match/EditMatchController.js